import HeroSection from './HeroSection';
import StatsSection from './StatsSection';
import ApproachSection from './ApproachSection';
import OurStorySection from './OurStorySection';
import ValuesSection from './ValueSection';
import TestimonialsSection from './Testimonials';
import SEO from '../SEO';

const AboutUsSection = () => {
  return (
    <div className="min-h-screen bg-white text-[#15302B]">
      <SEO
        title="About Us | MetaFit Wellness"
        description="Learn about MetaFit Wellness — our mission to connect individuals with certified practitioners, holistic healers, yoga experts, and wellness consultants across India."
        keywords="about metafit, wellness mission, holistic wellness India, certified practitioners, wellness journey"
        url="https://www.metafitwellness.com/about"
        canonical="https://www.metafitwellness.com/about"
        image="https://www.metafitwellness.com/metafit.webp"
      />
      {/* Hero Section */}
      <HeroSection />

      {/* Stats Section */}
      <StatsSection />

      {/* Our Approach to Wellbeing Section */}
      <ApproachSection />

      {/* Our Story Section */}
      <OurStorySection />

      {/* Values Section */}
      <ValuesSection />

      {/* Testimonials Section */}
      <TestimonialsSection />
    </div>
  );
};

export default AboutUsSection;
